import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled, { createGlobalStyle } from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import { Box, Header, Content } from '@spa/shared/components/Modal/styles';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
export var ModalGlobalStyle = /*#__PURE__*/createGlobalStyle([".double-booking{", "{width:555px;", "}", "{justify-content:end;border-width:0;", "}", "{", "}}"], Box, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n      "]))), Header, mediaMin.mediumBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        border-width: 1px;\n      "]))), Content, mediaMin.mediumBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        height: 100%;\n        width: 100%\n      "]))));
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-3yo0v0-0"
})(["display:flex;flex-direction:column;gap:", ";overflow:auto;"], function (props) {
  return props.theme.gap(6, 'column');
});
export var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-3yo0v0-1"
})(["display:flex;flex-direction:column;align-items:center;gap:", ";"], function (props) {
  return props.theme.gap(4, 'column');
});
export var ActionsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-3yo0v0-2"
})(["display:flex;flex-direction:column;gap:", ";& > ", "{border:none;}"], function (props) {
  return props.theme.gap(1, 'column');
}, Button);
export var MainActionsWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3yo0v0-3"
})(["display:flex;gap:", ";width:100%;", " ", "{width:100%;}"], function (props) {
  return props.theme.gap(4);
}, mediaMin.mediumBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    gap: ", ";\n  "])), function (props) {
  return props.theme.gap(2, 'column');
}), Button);
export var Title = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3yo0v0-4"
})(["font-size:", ";font-weight:600;line-height:", ";text-align:center;"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
});
export var Text = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-3yo0v0-5"
})(["font-size:", ";font-weight:400;line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});